import { Collection } from "../api/types";
import { unsplashImageUrl } from "../utils/unsplashImage";

export const collections: Collection[] = [
    {
        id: "gid://shopify/Collection/1",
        handle: "objects",
        title: "Objects",
        description: "Vases, ceramics and decorative pieces, chosen for material honesty and quiet presence.",
        image: {
            url: unsplashImageUrl("photo-1572725350945-a2d24faa89b0", 1200, 900),
            altText: null,
            width: 1200,
            height: 900,
        },
    },
    {
        id: "gid://shopify/Collection/2",
        handle: "lighting",
        title: "Lighting",
        description: "Table, floor and pendant lighting designed to shape a room through warmth, not wattage.",
        image: {
            url: unsplashImageUrl("photo-1606540037924-ee0470e33abf", 1200, 900),
            altText: null,
            width: 1200,
            height: 900,
        },
    },
    {
        id: "gid://shopify/Collection/3",
        handle: "furniture",
        title: "Furniture",
        description: "Small furniture in solid wood and stone, built to be lived with for decades, not seasons.",
        image: {
            url: unsplashImageUrl("photo-1750306956970-10d4eec3a9a8", 1200, 900),
            altText: null,
            width: 1200,
            height: 900,
        },
    },
    {
        id: "gid://shopify/Collection/4",
        handle: "textiles",
        title: "Textiles",
        description: "Linen, wool and jute pieces that soften a space and improve with every use.",
        image: {
            url: unsplashImageUrl("photo-1734786165046-40caffb38a9a", 1200, 900),
            altText: null,
            width: 1200,
            height: 900,
        },
    },
];
